/* eslint-disable react-hooks/exhaustive-deps */

import {Navigate} from "react-router-dom";
import {getAuth,  onAuthStateChanged ,  } from "firebase/auth";
import {ChangePlan} from '../signup/form/plan';
import React ,{ useState,useEffect } from 'react';



export const RequireAuth  = () => {

  


  const [tokenResult, setTokenResult] = useState(true);

  const [authUser, setUser] = useState(null);

  

  useEffect( () => {

    const auth = getAuth()
    onAuthStateChanged(auth, (user) => {
        if (user) {
          // User is signed in.
          setUser(user)
          setTokenResult(true)
        } else {
          setTokenResult(false)
          // No user is signed in.
        }
      });

  

  }, [tokenResult, authUser])


  return (
    <>
     { tokenResult === true ? <ChangePlan authUser = {authUser} /> :<Navigate replace to="/authenticate" />}
    </>
   );

    // page loaded only issue otherwise working
    
  }
  


